<template>
	<div class="group-thank-tile">
		<carousel
			id="carousel"
			:per-page="1"
			:navigationEnabled="true"
			:paginationEnabled="false"
			:loop="true"
			v-if="cause && organizations"
		>
			<slide>
				<div class="icon">
					<img
						v-if="cause"
						v-bind:src="cause.icon"
						v-bind:style="{ width: '100%', height: '100%' }"
					/>
				</div>
				<div class="thank-text">
					<h3>{{ cause.name }}</h3>
					<p>{{ cause.fact }}</p>
				</div>
			</slide>
			<slide
				v-for="org in organizations"
				:key="org.id"
				style="margin-bottom: 0px"
			>
				<thank-tile :institution="org" style="padding-bottom: 0px">
					<p slot="text">
						Your change allows us to
						{{
							org.full_impact_statement
								? org.full_impact_statement
								: ' make a difference'
						}}!
					</p>
					<h3 slot="org" v-bind:style="{ marginBottom: '-10px' }">
						{{ org.name }}
					</h3>
				</thank-tile>
			</slide>
		</carousel>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { Carousel, Slide } from 'vue-carousel'
import ThankTile from './ThankTile'

export default {
	name: 'group-thank-tile',
	components: { Carousel, Slide, ThankTile },
	data() {
		return {
			isSaving: false
		}
	},
	computed: {
		...mapGetters(['cause', 'organizations']),
		...mapState({
			home: ({ home }) => home.item
		})
	},
	mounted() {
		setTimeout(() => this.$forceUpdate(), 500)
	}
}
</script>

<style lang="scss">
.group-thank-tile {
	width: 100%;
	text-align: center;
	padding: 0 20px 0px;
	.VueCarousel {
		width: 100%;
		height: 100%;
		.VueCarousel-slide {
			visibility: visible;
			flex-basis: 100%;
			width: 100%;
		}
	}
	.thank-text {
		font-family: Bitter, serif;
		color: $dark-grey;
		font-weight: 400;
		-webkit-font-smoothing: antialiased;
	}
	.thank-encouragement {
		text-transform: uppercase;
		color: $dark-grey;
		font-weight: 600;
		opacity: 0.5;
	}
	.icon {
		border: 2px solid $navy;
		padding: 10px;
		background-color: #fff;
		border-radius: 10px;
		height: 100px;
		width: 100px;
		background: #fff;
		margin-top: 15px;
		margin-bottom: 25px;
		margin-left: auto;
		margin-right: auto;
	}
}
</style>
